export default __webpack_public_path__ + "static/photo-invoice-fb-share-02-26-2019-cc2462cab10f789a133e366bf88ff004.jpg";